import React, { useState } from 'react';
import { useIntl } from 'react-intl';

interface MessageInputProps {
    onSend: (text: string) => void;
    disabled: boolean;
}

const MessageInput = ({ onSend, disabled }: MessageInputProps) => {
    const intl = useIntl();
    const [inputValue, setInputValue] = useState('');

    const isInputEmpty = inputValue.trim().length === 0;
    const isSendDisabled = disabled || isInputEmpty;

    const handleSend = () => {
        if (isSendDisabled) {
            return;
        }
        onSend(inputValue.trim());
        setInputValue('');
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && !isSendDisabled) {
            event.preventDefault();
            handleSend();
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    return (
        <div className="input-group" data-testid="message-input-container">
            <input
                type="text"
                className="form-control"
                placeholder={intl.formatMessage({ id: 'intl-msg:chatbot.input.placeholder' })}
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                data-testid="message-input-field"
            />
            <span className="input-group-btn">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSend}
                    disabled={isSendDisabled}
                    data-testid="message-send-button"
                >
                    <span className="uikit-icon icon-send" aria-hidden="true" />
                </button>
            </span>
        </div>
    );
};

export default MessageInput;
